import {AfterViewInit, Component, EventEmitter, Inject, OnDestroy, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent } from '@angular/material/dialog';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { FaxLogsGridComponent } from './fax-logs-grid.component';

export interface FaxLogsFilterData {
  filter: any;
}

@Component({
    selector: 'app-fax-logs-dialog',
    templateUrl: './fax-logs-dialog.component.html',
    standalone: true,
    imports: [FlexModule, MatDialogTitle, MatIconButton, MatDialogClose, MatIcon, CdkScrollable, MatDialogContent, FaxLogsGridComponent]
})
export class FaxLogsDialogComponent implements OnInit, OnDestroy, AfterViewInit {

  filterChangeEvent = new EventEmitter<any>();

  constructor(public dialogRef: MatDialogRef<FaxLogsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: FaxLogsFilterData) {
  }

  ngOnInit() {
    console.log('dialog on init');
  }

  ngOnDestroy() {
  }

  ngAfterViewInit(): void {
    this.filterChangeEvent.emit(this.data.filter);
  }
}
